export type ChevronIconProps = {
  fillColor?: string;
  classes?: string;
};

export const ChevronIcon = ({ classes = '', fillColor }: ChevronIconProps) => (
  <svg
    className={`fill-current ${classes}`}
    width="14"
    height="9"
    viewBox="0 0 14 9"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.355 0.354999L7 5.69833L1.645 0.354998L6.11959e-07 2L7 9L14 2L12.355 0.354999Z"
      fill={fillColor}
    />
  </svg>
);
